import { forwardRef } from "react";

import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import useShare from "./useShare";

type BlueprintShareDropdownMenuItemProps = {
  blueprintId: string;
  isDisabled?: boolean;
};

const BlueprintShareDropdownMenuItem = forwardRef<
  HTMLDivElement,
  BlueprintShareDropdownMenuItemProps
>(function BlueprintShareDropdownMenuItem({ blueprintId, isDisabled }, ref) {
  const { onShare } = useShare(blueprintId);

  return (
    <DropdownMenuItem ref={ref} onAction={onShare} isDisabled={isDisabled}>
      Copy link to stack creation
    </DropdownMenuItem>
  );
});

export default BlueprintShareDropdownMenuItem;
